module.exports = __webpack_public_path__ + "img/logout.6992730f.svg";